<script setup lang="ts">
    import { useRecommendationPortal } from "@/stores/portal";
    import { useApp } from "@/stores/app";

    import TellScaleLogo from "@/components/tellscale/primitives/TellScaleLogo.vue";
    import AspectRatio from "@/components/shadcn/ui/aspect-ratio/AspectRatio.vue";

    const portal = useRecommendationPortal();
    const app = useApp();

    interface Props {
        size?: number;
    }

    withDefaults(defineProps<Props>(), {
        size: 10,
    });

    const logoUrl = computed<string | undefined>(() => {
        if(!portal.isLoaded || !portal.value) return undefined;

        if(app.isDarkMode && portal.value.company_logo_dark) {
            return portal.value.company_logo_dark;
        }

        return portal.value.company_logo;
    });

    const useTellScaleLogo = computed<boolean>(() => !logoUrl.value);
</script>

<template>
    <TellScaleLogo :size="size" v-if="useTellScaleLogo"/>

    <div v-else class="custom-img-width">
        <AspectRatio :ratio="16 / 9">
            <img :src="logoUrl!" class="object-contain w-full h-full" alt="User Logo"/>
        </AspectRatio>
    </div>
</template>

<style scoped>
    .custom-img-width {
        width: calc(v-bind(size) * 1rem);
    }
</style>